function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import RoundedButton from "../Buttons/RoundedButton.vue";
import SvgIconThreeHouses from "../SvgIcons/SvgIconThreeHouses.vue";
import SvgIconHouseWithCar from "../SvgIcons/SvgIconHouseWithCar.vue";
import SvgIconHouseWithTree from "../SvgIcons/SvgIconHouseWithTree.vue";
import SideModalButton from "../Buttons/SideModalButton.vue";
import SvgIconLineChart from "../SvgIcons/SvgIconLineChart.vue";
import SideModalNewsButton from "../Buttons/SideModalNewsButton.vue";
import SvgIconQuestionInCircle from "../SvgIcons/SvgIconQuestionInCircle.vue";
import SvgIconCircleWithPen from "../SvgIcons/SvgIconCircleWithPen.vue";
import SideModalPartnersCard from "../ProductPartnerCard/SideModalPartnersCard.vue";
import SvgIconCross from "../SvgIcons/SvgIconCross.vue";
import SvgIconPercent from "../SvgIcons/SvgIconPercent.vue";
import { moduleUrl, originUrl } from "../../Scripts/Utils";
import { sortBy } from 'lodash';
import SvgIconCalendar from "../SvgIcons/SvgIconCalendar.vue";
import SvgIconCalculatorWithBooks from "../SvgIcons/SvgIconCalculatorWithBooks.vue";
import SvgIconCalendarWithBooks from "../SvgIcons/SvgIconCalendarWithBooks.vue";
import SvgIconFolder from "../SvgIcons/SvgIconFolder.vue";
import SvgIconNoteWithClip from "../SvgIcons/SvgIconNoteWithClip.vue";
import SvgIconMoney from "componentsShared/SvgIcons/SvgIconMoney.vue";
import loadingSpinnerWithText from "../LoadingSpinnerWithText/LoadingSpinnerWithText.vue";
import { loadCompanies } from "../../../Modules/Methodology/Scripts/Loader";
export default {
  name: "v-side-modal",
  components: {
    "v-rounded-button": RoundedButton,
    "v-svg-icon-three-houses": SvgIconThreeHouses,
    "v-svg-icon-house-with-car": SvgIconHouseWithCar,
    "v-svg-icon-house-with-tree": SvgIconHouseWithTree,
    "v-side-modal-button": SideModalButton,
    "v-svg-icon-line-chart": SvgIconLineChart,
    "v-side-modal-news-button": SideModalNewsButton,
    "v-svg-icon-question-in-circle": SvgIconQuestionInCircle,
    "v-svg-icon-circle-with-pen": SvgIconCircleWithPen,
    "v-side-modal-partners-card": SideModalPartnersCard,
    "v-svg-icon-cross": SvgIconCross,
    "v-svg-icon-percent": SvgIconPercent,
    "v-svg-icon-calendar": SvgIconCalendar,
    "v-svg-icon-calculator-with-books": SvgIconCalculatorWithBooks,
    "v-svg-icon-calendar-with-books": SvgIconCalendarWithBooks,
    "v-svg-icon-folder": SvgIconFolder,
    "v-svg-icon-note-with-clip": SvgIconNoteWithClip,
    "v-svg-icon-money": SvgIconMoney,
    "v-loading-spinner-with-text": loadingSpinnerWithText
  },
  props: {
    initialData: {
      type: Object,
      required: false,
      default: null
    },
    sourceModal: {
      type: [Number, String],
      default: 1
    }
  },
  data: function data() {
    return {
      isMenuModalVisible: false,
      activeTab: this.sourceModal || 1,
      partnersHu: [],
      partnersNu: [],
      partnersSu: [],
      loading: true,
      isLoading: false,
      internalCompanies: [],
      loadingCompanies: false,
      companiesCache: new Map()
    };
  },
  computed: {
    localeShort: function localeShort() {
      return this.locale.split("-")[1].toLowerCase();
    },
    locale: function locale() {
      var _this$initialData$loc, _this$initialData;
      return (_this$initialData$loc = (_this$initialData = this.initialData) === null || _this$initialData === void 0 ? void 0 : _this$initialData.locale) !== null && _this$initialData$loc !== void 0 ? _this$initialData$loc : 'cs-CZ';
    },
    companiesUrlBase: function companiesUrlBase() {
      return "/Methodology/".concat(this.localeShort, "/Companies");
    },
    linkMetodikaHuCz: function linkMetodikaHuCz() {
      return originUrl("Methodology/cz/Mortgage");
    },
    linkMetodikaHuSk: function linkMetodikaHuSk() {
      return originUrl("Methodology/sk/Mortgage");
    },
    linkKalkulaceHu: function linkKalkulaceHu() {
      return this.originUrl("Rates/".concat(this.localeShort, "/Modelation"));
    },
    linkRatesPayments: function linkRatesPayments() {
      return this.originUrl("Rates/".concat(this.localeShort, "/Payments"));
    },
    linkRatesRefinance: function linkRatesRefinance() {
      return this.originUrl("Rates/".concat(this.localeShort, "/Refinance"));
    },
    linkRatesSpentCosts: function linkRatesSpentCosts() {
      return this.originUrl("Rates/".concat(this.localeShort, "/SpentCosts"));
    },
    linkUlozeneKalkulaceHu: function linkUlozeneKalkulaceHu() {
      // Centrální stránka uložených nabídek (nahrazuje starou /Rates/{id}/MyModelations).
      return this.originUrl("MyModelations?category=hu");
    },
    // Uložené nabídky SÚ/NÚ — stejná centrální stránka, jen s předvybranou kategorií.
    linkUlozeneNabidkySu: function linkUlozeneNabidkySu() {
      return this.originUrl("MyModelations?category=su");
    },
    linkUlozeneNabidkyNu: function linkUlozeneNabidkyNu() {
      return this.originUrl("MyModelations?category=nu");
    },
    linkOnlineZadostiHu: function linkOnlineZadostiHu() {
      return this.originUrl("Mortgages/cz/MyApplications");
    },
    linkMetodikaNu: function linkMetodikaNu() {
      return originUrl("Methodology/cz/Building");
    },
    linkMetodikaSu: function linkMetodikaSu() {
      return originUrl("Methodology/cz/PersonalLoan");
    },
    linkKalkulaceSu: function linkKalkulaceSu() {
      return originUrl("PersonalLoan/cz/List");
    },
    linkSplatkovyKalendarSu: function linkSplatkovyKalendarSu() {
      return originUrl("PersonalLoan/cz/Payments");
    },
    linkSplatkovyKalendarNu: function linkSplatkovyKalendarNu() {
      return originUrl("UnsecuredLoans/cz/Payments");
    },
    linkKalkulaceNu: function linkKalkulaceNu() {
      return originUrl("UnsecuredLoans/cz/modelation/create");
    },
    linkNovinky: function linkNovinky() {
      return originUrl("News");
    },
    showPartnersMethodology: function showPartnersMethodology() {
      return !!(this.partnersHu.length > 0 && this.getModuleInstance('Methodology'));
    },
    showPartnersMortgage: function showPartnersMortgage() {
      return !!(this.partnersHu.length > 0 && this.getModuleInstance('Mortgages'));
    },
    showPartnersSu: function showPartnersSu() {
      return !!(this.locale === 'cs-CZ' && this.partnersSu.length > 0);
    },
    // NU sekce (Nezajištěné úvěry) se řídí zapnutím produktu/modulu UnsecuredLoans
    // (ModuleInstances ⇐ unsecuredLoanProductPermissions), nezávisle na metodice –
    // analogicky k PersonalLoan. Tlačítko NU Metodika gatuje samostatně
    // showBuildingMethodology (UnsecuredLoanMethodologyPermissions). partnersNu zde
    // nelze použít: bere se z Methodology API gatovaného metodickým oprávněním.
    showPartnersNu: function showPartnersNu() {
      return !!(this.locale === 'cs-CZ' && this.getModuleInstance('UnsecuredLoans'));
    },
    // Tlačítko Metodika daného zdroje se zobrazí jen když k němu existují firmy.
    // Endpoint /Methodology/.../Companies/{source} vrací prázdno, pokud chybí
    // oprávnění (MethodologyPermissions / UnsecuredLoanMethodologyPermissions /
    // PersonalLoanMethodologyPermissions) — stejný zdroj pravdy jako dashboard.
    showMortgageMethodology: function showMortgageMethodology() {
      var _this$internalCompani;
      return (_this$internalCompani = this.internalCompanies) === null || _this$internalCompani === void 0 ? void 0 : _this$internalCompani.some(function (company) {
        return company.type === "Mortgage";
      });
    },
    showBuildingMethodology: function showBuildingMethodology() {
      var _this$internalCompani2;
      return (_this$internalCompani2 = this.internalCompanies) === null || _this$internalCompani2 === void 0 ? void 0 : _this$internalCompani2.some(function (company) {
        return company.type === "Building";
      });
    },
    showPersonalLoanMethodology: function showPersonalLoanMethodology() {
      var _this$internalCompani3;
      return (_this$internalCompani3 = this.internalCompanies) === null || _this$internalCompani3 === void 0 ? void 0 : _this$internalCompani3.some(function (company) {
        return company.type === "PersonalLoan";
      });
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.ensureCompaniesLoaded();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this$initialData2;
    window.addEventListener('open-side-modal', this.openMenuModal);
    var openMenuModalButton = document.getElementById("openMenuModal");
    if (openMenuModalButton) {
      openMenuModalButton.addEventListener("click", this.openMenuModal);
    }
    if ((_this$initialData2 = this.initialData) !== null && _this$initialData2 !== void 0 && (_this$initialData2 = _this$initialData2.moduleInstances) !== null && _this$initialData2 !== void 0 && _this$initialData2.length) {
      this.loadPartnersData();
    } else {
      console.warn("⚠️ SideModal skipped loadPartnersData – no moduleInstances available");
    }
  },
  methods: {
    originUrl: originUrl,
    moduleUrl: moduleUrl,
    cacheKey: function cacheKey(country, types) {
      var typesKey = (types && types.length ? _toConsumableArray(types).sort() : []).join(",");
      return "".concat(country, "|").concat(typesKey);
    },
    ensureCompaniesLoaded: function ensureCompaniesLoaded() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var hasMethodology, typesToLoad, key, companies, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              hasMethodology = !!_this2.getModuleInstance('Methodology'); // If no Methodology module, do not load any methodology companies
              if (hasMethodology) {
                _context2.n = 1;
                break;
              }
              _this2.internalCompanies = [];
              return _context2.a(2);
            case 1:
              typesToLoad = _this2.localeShort === "sk" ? ["Mortgage", "Building"] : ["Mortgage", "PersonalLoan", "Building"];
              key = _this2.cacheKey(_this2.localeShort, typesToLoad);
              if (!_this2.companiesCache.has(key)) {
                _context2.n = 2;
                break;
              }
              _this2.internalCompanies = _this2.companiesCache.get(key);
              return _context2.a(2);
            case 2:
              _this2.loadingCompanies = true;
              _context2.p = 3;
              _context2.n = 4;
              return loadCompanies(_this2.axios, _this2.companiesUrlBase, typesToLoad);
            case 4:
              companies = _context2.v;
              _this2.internalCompanies = companies || [];
              _this2.companiesCache.set(key, _this2.internalCompanies);
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              console.error("Failed to load side-modal methodology companies:", _t);
              _this2.internalCompanies = [];
            case 6:
              _context2.p = 6;
              _this2.loadingCompanies = false;
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, null, [[3, 5, 6, 7]]);
      }))();
    },
    getModuleInstance: function getModuleInstance(moduleName) {
      var _this$initialData3, _this$initialData3$fi;
      return ((_this$initialData3 = this.initialData) === null || _this$initialData3 === void 0 || (_this$initialData3 = _this$initialData3.moduleInstances) === null || _this$initialData3 === void 0 || (_this$initialData3$fi = _this$initialData3.find) === null || _this$initialData3$fi === void 0 ? void 0 : _this$initialData3$fi.call(_this$initialData3, function (moduleItem) {
        return moduleItem.moduleName === moduleName;
      })) || null;
    },
    loadPartnersData: function loadPartnersData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var slice, sources, requests, results, _iterator, _step, _step$value, source, data, comps;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.isLoading = true;
              slice = _this3.localeShort;
              sources = [];
              if (_this3.getModuleInstance('Methodology')) {
                // Mortgage partneři jdou z Rates scope BFF (filtr RatesPermissions).
                sources.push('mortgage');
              }
              if (_this3.getModuleInstance('PersonalLoan') && _this3.locale === "cs-CZ") {
                // PersonalLoan partneři z PersonalLoan BFF (filtr produktového oprávnění).
                sources.push('personalLoan');
              }
              if (_this3.getModuleInstance('UnsecuredLoans')) {
                // Building/NU partneři z UnsecuredLoans scope BFF (filtr produktového
                // oprávnění unsecuredLoanProductPermissions), nezávisle na metodice –
                // stejný princip jako PersonalLoan.
                sources.push('building');
              }
              requests = sources.map(function (source) {
                var url;
                if (source === "personalLoan") {
                  url = _this3.originUrl("PersonalLoan/".concat(slice, "/List/GetPersonalLoanPartners"));
                } else if (source === "mortgage") {
                  // Rates scope BFF — vraci uz prefiltrovane banky pres RatesPermissions
                  url = _this3.originUrl("Rates/".concat(slice, "/modelation/ratesPartners"));
                } else if (source === "building") {
                  // UnsecuredLoans scope BFF — prefiltrovane dle produktoveho opravneni,
                  // nezavisle na metodice (UnsecuredLoanMethodologyPermissions gatuje jen NU Metodiku).
                  url = _this3.originUrl("UnsecuredLoans/".concat(slice, "/partner/list"));
                } else {
                  url = _this3.originUrl("Methodology/".concat(slice, "/Companies/").concat(source));
                }
                return _this3.axios.get(url).then(function (res) {
                  return {
                    source: source,
                    data: res.data
                  };
                }).catch(function (err) {
                  console.error("Chyba při načítání", source, err);
                  return {
                    source: source,
                    data: []
                  };
                });
              });
              _context3.n = 1;
              return Promise.all(requests);
            case 1:
              results = _context3.v;
              _iterator = _createForOfIteratorHelper(results);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _step.value, source = _step$value.source, data = _step$value.data;
                  if (Array.isArray(data)) {
                    comps = data.map(function (item) {
                      if (item.name === "ČS") {
                        item.name = "CS";
                      }
                      return item;
                    });
                    comps = sortBy(comps, "id");
                    if (source === "mortgage") {
                      // Rates BFF vraci PartnerResponseDto (Id, BankCode, BankName).
                      // SideModalPartnersCard ocekava {uniqueShortcut, name, id} —
                      // mapujeme zachovani kompatibility s Methodology tvarem.
                      _this3.partnersHu = comps.map(function (p) {
                        return {
                          id: p.id,
                          uniqueShortcut: p.bankCode,
                          name: p.bankName
                        };
                      });
                    } else if (source === "building") {
                      // UnsecuredLoans BFF vrací {id, uniqueShortcut(=Code), name} —
                      // přesně formát očekávaný SideModalPartnersCard.
                      _this3.partnersNu = comps;
                    } else if (source === "personalLoan") {
                      _this3.partnersSu = sortBy(comps, "code");
                    }
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this3.isLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    openMenuModal: function openMenuModal() {
      this.isMenuModalVisible = true;
    },
    closeMenuModal: function closeMenuModal() {
      this.isMenuModalVisible = false;
    }
  }
};